import { useQuery, useQueryClient } from "@tanstack/react-query";
import { GetAllBlogs, GetOneBlog, GetSearchBlogs } from "../api/api";
export const useBlogs = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["blogs"],
    queryFn: async () => {
      const { data, error } = await GetAllBlogs();
      if (error) throw new Error(error);
      return data;
    },
    enabled: false,
    onSuccess: (data) => {
      if (data?.data?.length > 0) {
        queryClient.setQueryData(["blogs"], data);
      }
    },
  });
};
export const useSearchBlogs = (text) => {
  return useQuery({
    queryKey: ["one"],
    queryFn: async () => {
      if (!text || text.trim() === "" || text === "undefined") return [];
      const { data, error } = await GetSearchBlogs(text);
      if (error) throw new Error(error);
      return data;
    },
    enabled: false,
    cacheTime: 0,
    keepPreviousData: false,
  });
};

export const useBlog = (id) => {
  return useQuery({
    queryKey: ["blog", id],
    queryFn: async () => {
      const { data, error } = await GetOneBlog(id);
      if (error) throw new Error(error);
      return data;
    },
    enabled: !!id,
  });
};
